import { Field, getIn } from "formik";
export default function ErrorMessage({name}) {
    return (
        <>
            <style type={'text/css'}>
                {`
                    .error-field:hover{
                        width : fit-content;
                    }
                `}
            </style>
            <p className={"text-danger pt-1 ps-2 m-0 mb-2 text-truncate error-field bg-body"} style={{ height : "1.75rem"}}>
                <Field name={name}>
                    {
                        ({ form }) => {
                            const error = getIn(form.errors, name);
                            const touch = getIn(form.touched, name);
                            return touch || error ? error : null;
                        }
                    }
                </Field>
            </p>
        </>
    );
}
